




import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import BasePagination from "./BasePagination";
import {StoreInQuery} from "@/lib/helpers/customDecorators";
import {FormValues} from "@/types";

@Component({name: "QueryPagination", components: { BasePagination }})
export default class QueryPagination extends Vue {
  @Prop({ type: Number, required: true })
  public readonly totalPages!: number;

  @StoreInQuery()
  public setQuery(values: FormValues): FormValues {
    this.$emit("change", values.page);
    return values;
  }

  public get page(): number {
    const { query } = this.$route;
    return (Number(query.page) || 0) + 1;
  }

  public set page(page: number) {
    this.setQuery({page: page - 1});
  }

}
